import { defineStore } from 'pinia';

export type RootState = {
  flutterCameraFile: File | null;
  flutterImagePickerFiles: File[] | null;
  flutterFilePickerFiles: File[] | null;
}

export const useFlutterBus = defineStore({
  id: 'flutterBus',

  state: () => ({
    flutterCameraFile: null,
    flutterImagePickerFiles: null,
    flutterFilePickerFiles: null,
  } as RootState),
});
